export const makeHierarchyKey = (aggregationLevel, parentId) => `${aggregationLevel}::${parentId}`;

export default makeHierarchyKey;
